// Wishlist Quick View Modal - Alternative Fix with Cart Refresh
(function() {
  'use strict';
  
  let currentProduct = null;
  let selectedVariant = null;

  window.openWishlistQuickView = function(productId) {
    const productData = document.getElementById(`wishlist-product-data-${productId}`);
    if (!productData) {
      console.error('Product data not found for ID:', productId);
      return;
    }

    try {
      currentProduct = JSON.parse(productData.textContent);
      selectedVariant = currentProduct.variants[0];

      document.getElementById('wishlistModalTitle').textContent = currentProduct.title;
      document.getElementById('wishlistModalViewProduct').href = currentProduct.url;

      updateModalImages();
      updateModalPrice();
      createVariantOptions();

      const modal = document.getElementById('wishlistQuickViewModal');
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    } catch (error) {
      console.error('Error opening quick view:', error);
    }
  };

  window.closeWishlistQuickView = function() {
    const modal = document.getElementById('wishlistQuickViewModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  function updateModalImages() {
    const scrollContainer = document.getElementById('wishlistModalImagesScroll');
    if (!scrollContainer) return;

    scrollContainer.innerHTML = '';
    
    currentProduct.images.forEach((img) => {
      const imageItem = document.createElement('div');
      imageItem.className = 'quick-view-image-item';
      
      const imgElement = document.createElement('img');
      imgElement.src = img.src;
      imgElement.alt = img.alt;
      imgElement.loading = 'lazy';
      
      imageItem.appendChild(imgElement);
      scrollContainer.appendChild(imageItem);
    });

    setupScrollArrows();
  }

  function setupScrollArrows() {
    const scrollContainer = document.getElementById('wishlistModalImagesScroll');
    const leftBtn = document.getElementById('wishlistScrollLeftBtn');
    const rightBtn = document.getElementById('wishlistScrollRightBtn');

    if (!scrollContainer || !leftBtn || !rightBtn) return;

    leftBtn.replaceWith(leftBtn.cloneNode(true));
    rightBtn.replaceWith(rightBtn.cloneNode(true));

    const newLeftBtn = document.getElementById('wishlistScrollLeftBtn');
    const newRightBtn = document.getElementById('wishlistScrollRightBtn');

    newLeftBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollContainer.scrollBy({ left: -scrollContainer.offsetWidth * 0.8, behavior: 'smooth' });
    });

    newRightBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollContainer.scrollBy({ left: scrollContainer.offsetWidth * 0.8, behavior: 'smooth' });
    });

    function updateArrowsState() {
      newLeftBtn.disabled = scrollContainer.scrollLeft <= 0;
      newRightBtn.disabled = scrollContainer.scrollLeft >= (scrollContainer.scrollWidth - scrollContainer.offsetWidth - 5);
    }

    scrollContainer.addEventListener('scroll', updateArrowsState);
    setTimeout(updateArrowsState, 100);
  }

  function updateModalPrice() {
    const priceEl = document.getElementById('wishlistModalPrice');
    const comparePriceEl = document.getElementById('wishlistModalComparePrice');
    const addButton = document.getElementById('wishlistModalAddButton');

    if (!priceEl || !comparePriceEl || !addButton) return;

    const price = selectedVariant.price;
    const comparePrice = currentProduct.compare_at_price;

    priceEl.textContent = formatMoney(price);

    if (comparePrice && comparePrice > price) {
      comparePriceEl.textContent = formatMoney(comparePrice);
      comparePriceEl.style.display = 'inline';
    } else {
      comparePriceEl.style.display = 'none';
    }

    if (selectedVariant.available) {
      addButton.disabled = false;
      addButton.textContent = 'ADD TO CART';
    } else {
      addButton.disabled = true;
      addButton.textContent = 'Out of Stock';
    }
  }

  function createVariantOptions() {
    const optionsContainer = document.getElementById('wishlistModalOptions');
    if (!optionsContainer) return;

    optionsContainer.innerHTML = '';

    if (
      currentProduct.options.length === 0 ||
      (currentProduct.options.length === 1 && currentProduct.options[0].name === 'Title')
    ) {
      return;
    }

    currentProduct.options.forEach((option, optionIndex) => {
      const optionDiv = document.createElement('div');
      optionDiv.className = 'quick-view-option';

      const label = document.createElement('label');
      label.className = 'quick-view-option-label';
      label.textContent = option.name;
      optionDiv.appendChild(label);

      const valuesDiv = document.createElement('div');
      valuesDiv.className = 'quick-view-option-values';

      option.values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'quick-view-option-button';
        button.textContent = value;

        const isSelected = selectedVariant[`option${optionIndex + 1}`] === value;
        if (isSelected) {
          button.classList.add('active');
        }

        button.onclick = () => selectOption(optionIndex, value);
        valuesDiv.appendChild(button);
      });

      optionDiv.appendChild(valuesDiv);
      optionsContainer.appendChild(optionDiv);
    });
  }

  function selectOption(optionIndex, value) {
    const newVariant = currentProduct.variants.find((v) => {
      let matches = true;
      currentProduct.options.forEach((opt, idx) => {
        const optValue = idx === optionIndex ? value : selectedVariant[`option${idx + 1}`];
        if (v[`option${idx + 1}`] !== optValue) {
          matches = false;
        }
      });
      return matches;
    });

    if (newVariant) {
      selectedVariant = newVariant;
      updateModalPrice();
      createVariantOptions();
    }
  }

  // الحل البديل: جلب الـ cart كاملاً وإجبار التحديث
  window.addToCartFromWishlistModal = async function() {
    const addButton = document.getElementById('wishlistModalAddButton');

    if (!selectedVariant || !selectedVariant.available || !addButton) {
      console.error('Cannot add to cart');
      return;
    }

    addButton.disabled = true;
    const originalText = addButton.textContent;
    addButton.innerHTML = '<span class="modal-spinner"></span>';

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cart = cartDrawer || cartNotification;

      // 1. إضافة المنتج للـ cart
      const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: selectedVariant.id,
          quantity: 1
        }),
      });

      if (!addResponse.ok) {
        throw new Error(`HTTP error! status: ${addResponse.status}`);
      }

      const addData = await addResponse.json();

      if (addData.status === 422 || addData.status === 'error') {
        throw new Error(addData.description || addData.message || 'Failed to add to cart');
      }

      console.log('Product added:', addData);

      // 2. جلب الـ cart المُحدث مع الـ sections
      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sections = cart.getSectionsToRender().map((section) => section.id);
        const sectionsUrl = `${window.location.pathname}?sections=${sections.join(',')}`;

        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartData = await cartResponse.json();

        const sectionsResponse = await fetch(sectionsUrl);
        const sectionsData = await sectionsResponse.json();

        // دمج البيانات
        const fullData = {
          ...cartData,
          sections: sectionsData
        };

        // 3. إغلاق الموديال
        closeWishlistQuickView();

        // 4. شيل is-empty class
        if (cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        // 5. تحديث المحتوى
        await new Promise(resolve => setTimeout(resolve, 50));
        
        if (typeof cart.renderContents === 'function') {
          cart.renderContents(fullData);
        }

        // 6. فتح الـ drawer
        await new Promise(resolve => setTimeout(resolve, 100));
        
        if (typeof cart.open === 'function') {
          cart.open();
        }
      } else {
        // مافيش cart drawer
        closeWishlistQuickView();
        window.location = window.Shopify.routes.root + 'cart';
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      
      addButton.innerHTML = 'Error - Try Again';
      addButton.style.background = '#ef4444';

      setTimeout(() => {
        addButton.disabled = false;
        addButton.innerHTML = originalText;
        addButton.style.background = '';
      }, 2000);
    }
  };

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return window.Shopify?.currency?.active 
      ? `${window.Shopify.currency.active} ${amount}`
      : `LE ${amount}`;
  }

  function bindQuickViewButtons() {
    const buttons = document.querySelectorAll('.wishlist-quick-view-btn');
    
    buttons.forEach(btn => {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';
      
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const productId = this.dataset.productId;
        if (productId) {
          openWishlistQuickView(productId);
        }
      });
    });
  }

  function init() {
    bindQuickViewButtons();

    const observer = new MutationObserver(() => {
      bindQuickViewButtons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeWishlistQuickView();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();